import { RouteConfig } from "vue-router";

export const REmployerVisaCasesTemplate: RouteConfig = {
  path: ":candidateId(\\d+)",
  name: "EmployerVisaCasesTemplate",
  component: () =>
    import(
      /* webpackChunkName: "employer-visa-cases-template" */
      "./VEmployerVisaCasesTemplate.vue"
    ),
  meta: {
    title: "Back",
    backLink: "/",
    version: 2,
  },
};
